import PaginationInterface from '@core/interfaces/pagination-interface';
import Vue from 'vue';
import { Component, Prop, PropSync } from 'vue-property-decorator';

@Component({
  name: 'bpc-table-footer',
  components: {},
})
export default class TableFooter extends Vue {
  @PropSync('pagination', { type: Object })
  syncedPagination!: PaginationInterface;
  @Prop({ type: Boolean }) readonly simplePagination: boolean;
  @Prop({ type: Array, default: () => [5, 10, 15, 20, 50, 100, 200] })
  readonly pageOptions: number[];

  get totalRows() {
    if (!this.simplePagination) {
      return this.syncedPagination.total;
    }
    const lastItemOnPage = this.syncedPagination.to;
    const firtItemOnPage = this.syncedPagination.from;
    const diff = lastItemOnPage - (firtItemOnPage - 1);
    if (diff < this.syncedPagination.per_page) {
      return lastItemOnPage;
    }
    return lastItemOnPage + 1;
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
